import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "../../redux/blockchain/blockchainActions";
import { fetchData } from "../../redux/data/dataActions";
import { Container, Row, Card, Button, Col } from "react-bootstrap";
import { create } from "ipfs-http-client";
// import BlogCard from "./BlogsCards";
import rprpd from "../../Assets/rprpd.png";
import rpsh from "../../Assets/rpsh.png";
import rpcs from "../../Assets/rpcs.png";
import rpjb from "../../Assets/rpjb.png";
import rpmb from "../../Assets/rpmb.png";
import Particle from "../Particle2";
const projectId = '2DRNgdl8cgBHKRvIcCxjx2NNjVE';
const projectSecret = '629ca5dc5688ab4b4b14e3fd7de3242d';
const ipfsClient = require('ipfs-http-client');
const auth =
    'Basic ' + Buffer.from(projectId + ':' + projectSecret).toString('base64');
const client = ipfsClient.create({
    host: 'ipfs.infura.io',
    port: 5001,
    protocol: 'https',
    headers: {
        authorization: auth,
    },
});
// const ipfsClient = create("https://ipfs.infura.io:5001/api/v0");
const axios = require("axios");



function MintNFT(props) {
  const imageRDUri =
    'https://gateway.pinata.cloud/ipfs/QmeyUq72eYCYGNP9J3fGjkBhfoAaqbfDZaWRBDt4fkBrht'
  const imageSHUri =
    'https://gateway.pinata.cloud/ipfs/QmfNyntG6V14SvudnVcNqnDxzaruaBwza6SVtv6m9GG7uy'
  const imageCSUri =
    'https://gateway.pinata.cloud/ipfs/QmUk7yCNFBT7nByHX5hcATRh9EA1Pet5hV9KKEPUXSxsEN'
    const imageJBUri =
    'https://gateway.pinata.cloud/ipfs/QmTYYrkCj7R6u3bsQv25jkSqpVLX67Qh6kF6TGJUCAN76i'
    const imageMBUri =
    'https://gateway.pinata.cloud/ipfs/Qmav43TRmhSTwMGJ6skkBU5JP9sfVe7mgreNcC4nmGMQEU'
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [feedback, setFeedback] = useState("");
  const [claimingNft, setClaimingNft] = useState(false);
  const nftPurchaseAddress = '0x385Ab1db8d11dcac995722eFb0f63598Ff0e0318'
  const ipfsBaseUrl = "https://gateway.pinata.cloud/ipfs/";
  const name = "NFT name";
  const description = "IPFS minted nft woooooo.";
  const nftSeries = "RP";
  const imageURL = "";

  const claimRDNFTs = (_amount, _uri) => {
    if (_amount <= 0) {
      return;
    }
    setFeedback("Minting your RugpullDetective NFT...");
    setClaimingNft(true);
    const nftCost = _amount*500;
    blockchain.RUGPULL.methods
    .transfer(nftPurchaseAddress, blockchain.web3.utils.toWei((nftCost).toString(), "ether"))
      .send({
        gasLimit: "285000",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Payment Processed."
        );
    blockchain.rugpullDetectiveNFT.methods
      .mint(blockchain.account, _amount, _uri)
      .send({
        gasLimit: "285000",
        to: "0x385Ab1db8d11dcac995722eFb0f63598Ff0e0318",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Awesome, you have Successfully purchased a Rugpull Detective NFT. View your NFTs on the MyNFTs page."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
    });
  };

  const claimSHNFTs = (_amount, _uri) => {
    if (_amount <= 0) {
      return;
    }
    setFeedback("Minting your Surelock Holmes NFT...");
    setClaimingNft(true);
    const nftCost = _amount*500;
    blockchain.RUGPULL.methods
    .transfer(nftPurchaseAddress, blockchain.web3.utils.toWei((nftCost).toString(), "ether"))
      .send({
        gasLimit: "285000",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Payment Processed"
        );
    blockchain.surelockHolmesNFT.methods
      .mint(blockchain.account, _amount, _uri)
      .send({
        gasLimit: "285000",
        to: "0x385Ab1db8d11dcac995722eFb0f63598Ff0e0318",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Awesome, you have Successfully purchased a Surelock Holmes NFT. View your NFTs on the MyNFTs page."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
    });
  };

  const claimCSNFTs = (_amount, _uri) => {
    if (_amount <= 0) {
      return;
    }
    setFeedback("Minting your Carmella Santiago NFT...");
    setClaimingNft(true);
    const nftCost = _amount*500;
    blockchain.RUGPULL.methods
    .transfer(nftPurchaseAddress, blockchain.web3.utils.toWei((nftCost).toString(), "ether"))
      .send({
        gasLimit: "285000",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Payment Processed"
        );
    blockchain.carmellaSantiagoNFT.methods
      .mint(blockchain.account, _amount, _uri)
      .send({
        gasLimit: "285000",
        to: "0x385Ab1db8d11dcac995722eFb0f63598Ff0e0318",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Awesome, you have Successfully purchased a Carmella Santiago NFT. View your NFTs on the MyNFTs page."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
    });
  };

  const claimJBNFTs = (_amount, _uri) => {
    if (_amount <= 0) {
      return;
    }
    setFeedback("Minting your Jan Bond NFT...");
    setClaimingNft(true);
    const nftCost = _amount*300;
    blockchain.RUGPULL.methods
    .transfer(nftPurchaseAddress, blockchain.web3.utils.toWei((nftCost).toString(), "ether"))
      .send({
        gasLimit: "285000",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Payment Processed"
        );
    blockchain.janBondNFT.methods
      .mint(blockchain.account, _amount, _uri)
      .send({
        gasLimit: "285000",
        to: "0x385Ab1db8d11dcac995722eFb0f63598Ff0e0318",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Awesome, you have Successfully purchased a Jan Bond NFT. View your NFTs on the MyNFTs page."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
    });
  };

  const claimMBNFTs = (_amount, _uri) => {
    if (_amount <= 0) {
      return;
    }
    setFeedback("Minting your Mo Boosted NFT...");
    setClaimingNft(true);
    const nftCost = _amount*300;
    blockchain.RUGPULL.methods
    .transfer(nftPurchaseAddress, blockchain.web3.utils.toWei((nftCost).toString(), "ether"))
      .send({
        gasLimit: "285000",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Payment Processed"
        );
    blockchain.moBoostedNFT.methods
      .mint(blockchain.account, _amount, _uri)
      .send({
        gasLimit: "285000",
        to: "0x385Ab1db8d11dcac995722eFb0f63598Ff0e0318",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Awesome, you have Successfully purchased a Mo Boosted NFT. View your NFTs on the MyNFTs page."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
    });
  };

  const getData = () => {
    if (blockchain.account !== "") {
      dispatch(fetchData(blockchain.account));
    }
  };

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  const createMetaDataAndMint = async (_nftSeries, _name, _des, _imgBuffer) => {
    setClaimingNft(true);
    // setFeedback("Uploading to IPFS");
    try {
      const response = await axios.get(_imgBuffer,  { responseType: 'arraybuffer' });
      const buffer = Buffer.from(response.data, "utf-8");
      const addedImage = await client.add(buffer);
      const metaDataObj = {
        name: _name,
        description: _des,
        image: ipfsBaseUrl + addedImage.path,
      };
      const addedMetaData = await client.add(JSON.stringify(metaDataObj));
      console.log(ipfsBaseUrl + addedMetaData.path);
      switch (_nftSeries) {
        case "RPD":
          claimRDNFTs(1, ipfsBaseUrl + addedMetaData.path);
          break;
        case "SH":
          claimSHNFTs(1, ipfsBaseUrl + addedMetaData.path);
          break;
        case "CS":
          claimCSNFTs(1, ipfsBaseUrl + addedMetaData.path);
          break;
        case "JB":
          claimJBNFTs(1, ipfsBaseUrl + addedMetaData.path);
          break;
        case "MB":
          claimMBNFTs(1, ipfsBaseUrl + addedMetaData.path);
          break;
      }
      // mint(ipfsBaseUrl + addedMetaData.path);
    } catch (err) {
      console.log(err);
      setClaimingNft(false);
      setFeedback("An error has occured");
    }
  };

  const startMintingProcess = () => {
    createMetaDataAndMint(nftSeries, name, description, getImageData(imageURL));
  };

  const getImageData = (imgUrl) => {
    // const canvasEl = elementRef.current;
    let dataUrl = imgUrl.toDataURL("image/png");
    const buffer = Buffer(dataUrl.split(",")[1], "base64");
    return buffer;
  };
  return (
    <section>
      <Container fluid className="nftmint-section" id="Minter">
        <Particle />
        <Container >
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <h1 className="nftgallery-heading">
          <strong className="purple">Mint your NFT</strong>
        </h1>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <h5>
            <strong className="gold">{feedback}</strong>
          </h5>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="nft-card">
          <Card className="nft-card-view">
            <Card.Title style={{ textAlign: "center" }}>Rugpull Prevention</Card.Title>
            <Card.Title style={{ textAlign: "center" }}>Rugpull Detective NFT</Card.Title>
            <Card.Img variant="top" src={rprpd} alt="Rugpull Detective NFT's" />
            <Card.Body>
                <Card.Text style={{ textAlign: "justify" }}>
                Rugpull Detective NFT Series <br/> {data.totalSupplyRPD} of 150 Minted
                </Card.Text>
                <Button variant="primary" disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        createMetaDataAndMint("RPD", "Rugpull Detective", "Rugpull Detective NFT Series",imageRDUri);
                        getData();
                      }}
>
                {claimingNft ? "BUSY" : "BUY 1"}
                </Button>
                <Card.Text style={{ textAlign: "center" }}>
                  Price : 500 RUGPULL
                </Card.Text>
                <Card.Text style={{ textAlign: "center" }}>
                  <a href="https://snowtrace.io/address/0x6647093cda77a211be470e5eb3cd26202da2a41f" target="_blank">Contract : 0x6647093cda77a211be470e5eb3cd26202da2a41f</a>
                </Card.Text>
            </Card.Body>
        </Card>
            </Col>
          <Col md={4} className="nft-card">
          <Card className="nft-card-view">
            <Card.Title style={{ textAlign: "center" }}>Rugpull Prevention</Card.Title>
            <Card.Title style={{ textAlign: "center" }}>Surelock Holmes NFT</Card.Title>
            <Card.Img variant="top" src={rpsh} alt="Surelock Holmes NFT's" />
            <Card.Body>
                <Card.Text style={{ textAlign: "justify" }}>
                Surelock Holmes NFT Series <br/> {data.totalSupplySH} of 150 Minted
                </Card.Text>
                <Button variant="primary" disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        createMetaDataAndMint("SH", "Surelock Holmes", "Surelock Holmes NFT Series",imageSHUri);
                        getData();
                      }}
>
                {claimingNft ? "BUSY" : "BUY 1"}
                </Button>
                <Card.Text style={{ textAlign: "center" }}>
                  Price : 500 RUGPULL
                </Card.Text>
                <Card.Text style={{ textAlign: "center" }}>
                  <a href="https://snowtrace.io/address/0x9ffaacff2885448e1c833117a6af425066503429" target="_blank">Contract : 0x9ffaacff2885448e1c833117a6af425066503429</a>
                </Card.Text>
            </Card.Body>
        </Card>
            </Col>
          <Col md={4} className="nft-card">
          <Card className="nft-card-view">
            <Card.Title style={{ textAlign: "center" }}>Rugpull Prevention</Card.Title>
            <Card.Title style={{ textAlign: "center" }}>Carmella Santiago NFT</Card.Title>
            <Card.Img variant="top" src={rpcs} alt="Carmella Santiago NFT's" />
            <Card.Body>
                <Card.Text style={{ textAlign: "justify" }}>
                Carmella Santiago NFT Series <br/> {data.totalSupplyCS} of 150 Minted
                </Card.Text>
                <Button variant="primary" disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        createMetaDataAndMint("CS", "Carmella Santiago", "Carmella Santiago NFT Series",imageCSUri);
                        getData();
                      }}
>
                {claimingNft ? "BUSY" : "BUY 1"}
                </Button>
                <Card.Text style={{ textAlign: "center" }}>
                  Price : 500 RUGPULL
                </Card.Text>
                <Card.Text style={{ textAlign: "center" }}>
                  <a href="https://snowtrace.io/address/0x734b85ec4a24eff77d3453e5db0d419d2e120fb1" target="_blank">Contract : 0x734b85ec4a24eff77d3453e5db0d419d2e120fb1</a>
                </Card.Text>
            </Card.Body>
        </Card>
            </Col>
            <Col md={4} className="nft-card">
          <Card className="nft-card-view">
            <Card.Title style={{ textAlign: "center" }}>Rugpull Prevention</Card.Title>
            <Card.Title style={{ textAlign: "center" }}>Jan Bond NFT</Card.Title>
            <Card.Img variant="top" src={rpjb} alt="Jan Bond NFT's" />
            <Card.Body>
                <Card.Text style={{ textAlign: "justify" }}>
                Jan Bond NFT Series <br/> {data.totalSupplyJB} of 300 Minted
                </Card.Text>
                <Button variant="primary" disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        createMetaDataAndMint("JB", "Jan Bond", "Jan Bond NFT Series",imageJBUri);
                        getData();
                      }}
>
                {claimingNft ? "BUSY" : "BUY 1"}
                </Button>
                <Card.Text style={{ textAlign: "center" }}>
                  Price : 300 RUGPULL
                </Card.Text>
                <Card.Text style={{ textAlign: "center" }}>
                  <a  href="https://snowtrace.io/address/0x9a625e7246926821799c6E58983eba87cBBAe945" target="_blank">Contract : 0x9a625e7246926821799c6E58983eba87cBBAe945</a>
                </Card.Text>
            </Card.Body>
        </Card>
            </Col>
            <Col md={4} className="nft-card">
          <Card className="nft-card-view">
            <Card.Title style={{ textAlign: "center" }}>Rugpull Prevention</Card.Title>
            <Card.Title style={{ textAlign: "center" }}>Mo Boosted NFT</Card.Title>
            <Card.Img variant="top" src={rpmb} alt="Mo Boosted NFT's" />
            <Card.Body>
                <Card.Text style={{ textAlign: "justify" }}>
                Mo Boosted NFT Series <br/> {data.totalSupplyMB} of 300 Minted
                </Card.Text>
                <Button variant="primary" disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        createMetaDataAndMint("MB", "Mo Boosted", "Mo Boosted NFT Series",imageMBUri);
                        getData();
                      }}
>
                {claimingNft ? "BUSY" : "BUY 1"}
                </Button>
                <Card.Text style={{ textAlign: "center" }}>
                  Price : 300 RUGPULL
                </Card.Text>
                <Card.Text style={{ textAlign: "center" }}>
                  <a  href="https://snowtrace.io/address/0x51788ec25D5a710300218c345C03EB9dD0C3B3dD" target="_blank">Contract : 0x51788ec25D5a710300218c345C03EB9dD0C3B3dD</a>
                </Card.Text>
            </Card.Body>
        </Card>
            </Col>
          </Row>

          <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}></Row>
        </Container>
      </Container>
    </section>
  )
}

export default MintNFT
